import { reviewConstants } from '../redux-constants'

const initialState = {
    list: [],
    error: null,
    loading: false,
    //checkReviews: null
}

export default function review(state = initialState, action) {
    switch (action.type) {
        case reviewConstants.LOADING_REVIEWS_REQUEST:
            state.loading = true
            state.error = null
            return state

        case reviewConstants.LOADING_REVIEWS_FAILURE:
            state.loading = false
            state.error = action.payload
            //state.checkCoworkings = true
            return state

        case reviewConstants.LOADING_REVIEWS_DONE:
            state.loading = false
            //state.checkCoworkings = true
            return state
        case reviewConstants.UPDATE_REVIEWS:
            const restaurantIndex = state.list.findIndex(
                x => x.id === action.payload.id
            )
            state.list =
                restaurantIndex === -1
                    ? state.list.concat(action.payload)
                    : state.list.map(item => {
                          return item.id === action.payload.id
                              ? {
                                    ...action.payload,
                                }
                              : item
                      })
            state.loading = false
            return state
        default:
            return state
    }
}
